<script>
import eventHelper from "@/mixins/eventHelper.js";
import apiHelper from "@/mixins/apiHelper.js";

export default {
  emits: ['selectedAgendasChanged'],
  mixins: [
    eventHelper,
    apiHelper,
  ],
  mounted() {
    this.setDefaultSelectedAgendas();
  },
  watch: {
    itemsSelected: {
      handler: function (newVal, oldVal) {
        // Get currently logged-in user ID
        let user_id = drupalSettings.user.uid;
        // Emit the selected agendas to the parent component
        this.$emit('selectedAgendasChanged', newVal);
        // Store the selected agendas in localStorage
        localStorage.setItem('selectedAgendas.'+user_id, JSON.stringify(newVal));
      },
      deep: true
    }
  },
  props: {
    agendas: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      itemsSelected: {
        users: [],
        color: [],
      },
    };
  },
  computed: {
    loading() {
      return this.agendas.users.length === 0 && this.agendas.color.length === 0;
    },
  },
  methods: {
    setDefaultSelectedAgendas() {
      // Get currently logged-in user ID
      let user_id = drupalSettings.user.uid;

      let savedSelections = localStorage.getItem('selectedAgendas.'+user_id);
      if (savedSelections) {
        this.itemsSelected = JSON.parse(savedSelections);
      } else {
        // Preselect our own user agenda
        this.itemsSelected.users = [user_id];
      }
    },
  }
}
</script>

<template>

  <Toast position="top-center" group="global" />

  <template v-if="loading">
    <Skeleton width="6rem" class="mb-2"></Skeleton>
    <Skeleton width="5rem" class="mb-2"></Skeleton>
    <Skeleton width="4rem" class="mb-2"></Skeleton>
    <Skeleton width="3rem" class="mb-2"></Skeleton>
    <Skeleton width="4rem" class="mb-2"></Skeleton>
  </template>

  <template v-if="!loading">

    <ScrollPanel header="Agendas" style="width: 100%; height: 100%;">
      <div v-for="item of agendas.users" :key="item.id" class="flex items-center py-1">
        <Checkbox
          v-model="itemsSelected.users"
          :inputId="item.id"
          name="user"
          :value="item.id"
          :pt="{
            box: { style: 'background-color: '+item.color+';' },
          }" />
        <label :for="item.id" class="ml-1">{{ item.name }}</label>
      </div>
      <template v-if="agendas.color.length">
        <Divider />
        <h3>Klant agendas</h3>
        <p>Selecteer niks als u alles wilt zien.</p>
        <div v-for="item of agendas.color" :key="item.id" class="flex items-center py-1">
          <Checkbox
            v-model="itemsSelected.color"
            :inputId="item.id"
            name="color"
            :value="item.id"
            :pt="{
            box: { style: 'background-color: '+item.color+';' },
          }" />
          <label :for="item.id" class="ml-1">{{ item.name }}</label>
        </div>
      </template>
      <a href="/settings/agenda">Beheren</a>
    </ScrollPanel>

  </template>

</template>

<style>
 /* See agenda.scss for styling. Styling is here because we want the Gin/Bootstrap variables. */
</style>
